export class Idioma {
    idIdioma: number;
    nombre: string;
    columna: string;
    predeterminado: boolean;
    locale: string;
}
